import { cn } from "@/lib/utils";

type CountryFlagIconProps = {
  iso2?: string | null;
  countryName?: string | null;
  className?: string;
};

export function countryNameToIso2(countryName?: string | null): string | null {
  if (!countryName) return null;
  const n = countryName.toLowerCase().trim();
  if (n.includes("japan")) return "jp";
  if (n.includes("united kingdom") || n.includes("uk") || n.includes("britain") || n.includes("england")) return "gb";
  if (n.includes("germany")) return "de";
  if (n.includes("united states") || n.includes("usa") || n.includes("us")) return "us";
  if (n.includes("united arab emirates") || n.includes("uae") || n.includes("dubai")) return "ae";
  if (n.includes("thailand")) return "th";
  if (n.includes("south korea") || n.includes("korea")) return "kr";
  if (n.includes("china")) return "cn";
  if (n.includes("canada")) return "ca";
  if (n.includes("australia")) return "au";
  if (n.includes("pakistan")) return "pk";
  if (n.includes("singapore")) return "sg";
  if (n.includes("malaysia")) return "my";
  if (n.includes("indonesia")) return "id";
  if (n.includes("india")) return "in";
  if (n.includes("turkey")) return "tr";
  if (n.includes("france")) return "fr";
  if (n.includes("italy")) return "it";
  if (n.includes("spain")) return "es";
  if (n.includes("sweden")) return "se";
  if (n.includes("switzerland")) return "ch";
  return null;
}

export function CountryFlagIcon({ iso2, countryName, className }: CountryFlagIconProps) {
  const code = (iso2 ?? "").trim().toLowerCase() || countryNameToIso2(countryName);

  if (code && code.length === 2) {
    return (
      <img
        src={`https://flagcdn.com/24x18/${code}.png`}
        srcSet={`https://flagcdn.com/48x36/${code}.png 2x`}
        width="20"
        height="15"
        alt={countryName ?? code.toUpperCase()}
        className={cn(
          "h-3.5 w-5 object-cover rounded-xs border border-black/20 shadow-2xs shrink-0 inline-block align-middle",
          className,
        )}
        loading="lazy"
        onError={(e) => {
          (e.target as HTMLElement).style.display = "none";
        }}
      />
    );
  }

  return <span className={cn("text-xs opacity-70 shrink-0 inline-block align-middle", className)}>🌐</span>;
}
